import queryString from 'query-string';
import GuestIdForm from 'src/containers/CheckIn/guestIdForm';
import GuestData from 'src/containers/CheckIn/guestData';
import useCheckInGuest from 'src/containers/CheckIn/useCheckInGuest';
import { CheckinURL } from 'src/components/helpers';

const SERVICE_EVENT_URL = CheckinURL('Auditorio_Principal');

const ServiceCheckIn = (props) => {
  const parsedQueryString = queryString.parse(props.location.search);
  const eventSN = parsedQueryString.eventSN || 'Auditorio_Principal';

  const {
    guestID,
    setGuestID,
    Attendant,
    setAttendant,
    loadedData,
    errorData,
    setErrorData,
    getAttendant,
    getAttendantInfo,
    resetForm,
    handleInputs,
    handleDropDown,
  } = useCheckInGuest({
    eventURL: SERVICE_EVENT_URL,
    getRequestBody: () => ({
      eventSlugname: eventSN,
      ...(parsedQueryString.eventId ? { eventId: parsedQueryString.eventId } : {}),
    }),
    initialId: parsedQueryString.id,
  });

  const handleReset = () => {
    resetForm();
    const nextQuery = queryString.stringify({
      eventSN,
      ...(parsedQueryString.eventId ? { eventId: parsedQueryString.eventId } : {}),
    });
    props.history.push(`/checkin/servicio?${nextQuery}`);
  };

  const onEventSNChange = (value) => {
    const nextQuery = queryString.stringify({
      eventSN: value,
      ...(parsedQueryString.id ? { id: parsedQueryString.id } : {}),
      ...(parsedQueryString.eventId ? { eventId: parsedQueryString.eventId } : {}),
    });
    props.history.push(`/checkin/servicio?${nextQuery}`);
  };

  return Attendant.name ? (
    <GuestData
      mode="servicio"
      Attendant={Attendant}
      handleInputs={handleInputs}
      resetForm={handleReset}
      errorData={errorData}
      set_errorData={setErrorData}
      set_Attendant={setAttendant}
      location={props.location}
      handleDropDown={handleDropDown}
      getAttendantInfo={getAttendantInfo}
    />
  ) : (
    <GuestIdForm
      title="Ingreso Servicio"
      guestID={guestID}
      set_guestID={setGuestID}
      getAttendant={getAttendant}
      history={props.history}
      loadedData={loadedData}
      errorData={errorData}
      showEventSelect
      eventSN={eventSN}
      onEventSNChange={onEventSNChange}
    />
  );
};

export default ServiceCheckIn;
